import config from '../../config';

export default {
  url: `${config.api
    .baseURL}/accounts/:accountId/profiles/:profileId/dischargeProgress`,
  transformer(data) {
    return data;
  }
};



// WEBPACK FOOTER //
// ./src/api/dischargeProgress/list.js